import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const ViewRcptkModal = ({ show, handleClose, onRowSelect }) => {

  const [searchEmpName, setSearchEmpName] = useState();

  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {

    const fetchLists = async () => {
      try {

        populateGrid();

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);


  const handleSearch = async () => {

    populateGrid();

  };

  const handleClear = async () => {

    setSearchEmpName('');
    setSearchResults([]);
    populateGrid();

  }

  const populateGrid = async () => {

    try {

      setSearchResults([]);

      const response = await axios.get(`${BASE_URL}/api/get_employee_list`, {
        params: { p_emp_name: searchEmpName || '' }
      });

      setSearchResults(response.data);

    } catch (e) {

    }

  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Search Employee</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            {/* Section Dropdown */}
            <Form.Group className="col-md-8">
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Employee Name</InputGroup.Text>
                <input style={{ textAlign: 'left' }}
                  className="form-control"
                  name="searchEmpName"
                  value={searchEmpName}
                  onChange={(e) => setSearchEmpName(e.target.value)}
                />
              </InputGroup>
            </Form.Group>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
              <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '50%', textAlign: 'left' }}>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="1" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.emp_name}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="warning" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewRcptkModal;
